import React, { useState } from 'react';
import { find } from 'lodash';
import { Form } from 'react-form';
import Modal from '../../../components/Modal/ReactBootstrapModal';
import { objectHasValues } from '../../../utils/misc';

import Select from '../../../components/Form/Select';

const _ = { find };

// supports v2 typeIds
const StripeWithdrawModal = (props) => {
    const { withdrawPlayer, confirmPopup, onCloseClick, divisions, currency, regPaymentRefund } = props;
    const { divisionAmounts } = regPaymentRefund;

    const [step, setStep] = useState(1);

    const registeredDivisionIds = withdrawPlayer.registeredDivisions.map(d => d.divisionId);
    const registeredDivisions = divisions.filter(d => {
        return registeredDivisionIds.includes(d.id);
    });

    const defaultValues = {};

    const paidOptions = [
        {
            id: 1,
            label: 'Withdraw without Refund',
        },
        {
            id: 2,
            label: 'Withdraw and Refund',
        },
        {
            id: 3,
            label: 'Refund Only',
        },
    ];

    const freeOptions = [
        {
            id: 1,
            label: 'Withdraw without Refund',
        },
    ];

    const handlePreviousStepClick = () => {
        setStep(1);
    };

    const filterDivisions = (values, withdraws) => {
        // return withdraws
        if (withdraws) {
            return divisions.filter(d => {
                return values[d.id] && (values[d.id] === '1' || values[d.id] === '2');
            });
        }
        // return refunds
        return divisions.filter(d => {
            return values[d.id] && (values[d.id] === '2' || values[d.id] === '3');
        });
    };

    const displayRefunds = (refundDivisions) => {
        console.log('refundDivisions', refundDivisions);
        const totals = {
            paid: 0,
            eventFeeTotal: 0,
            percentFees: 0,
            organizer: 0,
            verifiedFees: 0,
            totalRefund: 0,
        };
        if (divisionAmounts) {
            refundDivisions.forEach(division => {
                const amounts = _.find(divisionAmounts, { divisionId: division.id });
                if (amounts) {
                    totals.paid += amounts.entryFeePaid + amounts.verificationFeePaid;
                    totals.eventFeeTotal += amounts.entryFeePaid;
                    totals.percentFees += amounts.percentFeeTotal;
                    totals.organizer = totals.eventFeeTotal - totals.percentFees;
                    totals.verifiedFees += amounts.verificationFeePaid;
                    totals.totalRefund = totals.eventFeeTotal + totals.verifiedFees;
                }
            });
        }
        if (regPaymentRefund.loading) {
            return <p className="mt40">Loading refund amounts...</p>;
        }
        if (regPaymentRefund.loaded && regPaymentRefund.error) {
            return <p className="mt40">Error loading refund amounts...</p>;
        }
        if (regPaymentRefund.loaded && !regPaymentRefund.error) {
            return (
                <>
                    <p className="mt40">The player paid: <span className="text-dark">{currency.symbol}{+parseFloat(totals.paid).toFixed(2)}</span></p>
                    <p className="mt16">Event Fees to be Refunded: <span className="text-dark">{currency.symbol}{+parseFloat(totals.eventFeeTotal).toFixed(2)}</span></p>
                    <ul>
                        <li>Total Percent Fees: {currency.symbol}{+parseFloat(totals.percentFees).toFixed(2)}</li>
                        <li>Organizer Total: {currency.symbol}{+parseFloat(totals.organizer).toFixed(2)}</li>
                    </ul>
                    <p className="">Verified Fees: <span className="text-dark">{currency.symbol}{+parseFloat(totals.verifiedFees).toFixed(2)}</span></p>
                    <p className="text-bold text-dark mt24">Total refund: {currency.symbol}{+parseFloat(totals.totalRefund).toFixed(2)}</p>
                </>
            );
        }
        return null;
    };

    const handleSubmitClick = ({ values }) => {
        console.log('step 1', values);
        if (step === 1 && objectHasValues(values)) {
            setStep(2);
        } else if (step === 2) {
            const stripeWithdrawReq = {
                withdrawRequest: {
                    memberIds: [withdrawPlayer.memberId],
                    divisionIds: [],
                },
                refundRequest: {
                    memberIds: [withdrawPlayer.memberId],
                    divisionIds: [],
                },
                refundReason: `Event withdrawal requested by player/organizer.`,
            };
            Object.entries(values).forEach(([divisionId, option]) => {
                if (option === '1') { // Withdraw without Refund
                    stripeWithdrawReq.withdrawRequest.divisionIds.push(divisionId);
                } else if (option === '2') { // Withdraw and Refund
                    stripeWithdrawReq.withdrawRequest.divisionIds.push(divisionId);
                    stripeWithdrawReq.refundRequest.divisionIds.push(divisionId);
                } else if (option === '3') { // Refund Only
                    stripeWithdrawReq.refundRequest.divisionIds.push(divisionId);
                }
            });
            confirmPopup(stripeWithdrawReq);
        }
    };

    return (
        <Form onSubmit={values => handleSubmitClick({ values })} defaultValues={defaultValues}>
            {({ submitForm, values }) => (
                <form onSubmit={submitForm} id="selectClubSubTypeForm">
                    <Modal visible={true} onClickBackdrop={onCloseClick} className="full-screen">
                        <div className="modal-header">
                            <div className="text-medium">Withdraw/Refund Player</div>
                            <div className="close-icon" onClick={onCloseClick}><i className="utr utr-close" /></div>
                        </div>
                        {step === 1 && (
                            <div className="modal-body">
                                <h5 className="mb24 lh40"><span className="text-gray">Adjust Registration for</span> {withdrawPlayer.displayName}</h5>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group form-group-xl">
                                            {/* <RadioGroup field="step1">
                                                {step1RadioOptions.map((option, i) => (
                                                    <RadioButton
                                                        key={option.id}
                                                        label={`${option.label}`}
                                                        description={option.description}
                                                        value={option.id}
                                                        id={`step1${i}`}
                                                        disabled={false}
                                                    />
                                                ))}
                                            </RadioGroup> */}
                                            {registeredDivisions.map(d => (
                                                <div className={`division-card registered card-border highlight-teal`} key={d.id}>
                                                    <div className="details">
                                                        <div className="h6">{d.name}<span className="price float-right">{d.price}</span></div>
                                                        <div className="description w-100 mt8">
                                                            <Select
                                                                formGroupCssClass={`mb0`}
                                                                id={d.id}
                                                                emptyOption={`No Action`}
                                                                field={`${d.id}`}
                                                                options={d.entryFee ? paidOptions : freeOptions}
                                                                attributeToSave={`id`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div className="modal-body">
                                <p className="text-bold text-dark">Confirm registration change</p>
                                <p>Please review the change before confirming. This cannot be undone.</p>
                                <p className="mt40">The player will be withdrawn from the following divisions:</p>
                                <ul>
                                    {filterDivisions(values, true).map(d => <li className="text-dark">{d.name} ({d.price})</li>)}
                                </ul>
                                {!!filterDivisions(values, false).length && (
                                    <>
                                        <p>The player will be refunded for the following divsions:</p>
                                        <ul>
                                            {filterDivisions(values, false).map(d => <li className="text-dark">{d.name} ({d.price})</li>)}
                                        </ul>
                                        {displayRefunds(filterDivisions(values, false))}
                                    </>
                                )}
                            </div>
                        )}
                        <div className="modal-footer bt0">
                            <div className="container w-100">
                                <div className="row">
                                    {step === 2 && (
                                        <div className="col-6">
                                            <button
                                                type="button"
                                                className={`btn btn-default btn-xl text-uppercase btn-block`}
                                                onClick={handlePreviousStepClick}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    )}
                                    <div className={`col-${step === 1 ? '12' : '6'}`}>
                                        <button
                                            type="submit"
                                            className={`btn btn-xl btn-block btn-primary text-uppercase`}
                                            disabled={!objectHasValues(values) || (step === 2 && regPaymentRefund.loading)}
                                        >
                                            {step === 1 && 'Next'}
                                            {step === 2 && (!filterDivisions(values, false).length ? 'Withdraw' : 'Refund')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </form>
            )}
        </Form>
    );
};

export default StripeWithdrawModal;
